import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Spin, Button } from 'antd';
import { Switch, Route, Link, Redirect } from 'react-router-dom';
import Icon from 'material-ui/Icon';

import BizButton from '../../components/UI/BizIconButton';
import LeadDataSheet from './LeadDataSheet';
import LeadApprovalSheet from './LeadApprovalSheet';
import LeadApprovalSheetForm from './LeadApprovalSheetForm';
import LeadConversionSheet from './LeadConversionSheet';
import LeadConversionSheetForm from './LeadConversionSheetForm';
import LdsFisRequest from './LdsFisRequest';
import LdsFis from './LdsFis';
import LcsFisRequest from './LcsFisRequest';
import LcsFisForm from './LcsFisForm';
import MandateCreate from './MandateCreate';

import QUERY from '../../graphql/queries/leadQuery.graphql';
import statusLogMutation from '../../graphql/mutations/addStatusLogMutation.graphql';

import { baseUrl } from '../../utils/globals';

class LeadPage extends React.Component {
  state = {
  };

  render() {
    const { path, url, params } = this.props.match;
    const { loading } = this.props.data;

    if (loading) {
      return <Spin size="large" />;
    }

    console.log(this.props.data.lead);
    const { name, statusLogsList, status, lds, ldsFis, docs, las, lcsFis, lcs } = this.props.data.lead;

    return (
      <div>
        <div className="container-fluid" style={{ paddingTop: 20 }}>
          <h2 className="page-title">{name}</h2>
          <div className="row">
            <div className="col-auto">
              <BizButton title="Change Project Owner" theme="lac"><Icon style={{ fontSize: 22, color: '#FFFFFF' }}>person</Icon></BizButton>
            </div>
            <div className="col-auto">
              <BizButton title="Reject Lead" theme="lac"><Icon style={{ fontSize: 22, color: '#FFFFFF' }}>not_interested</Icon></BizButton>
            </div>
            <div className="col-auto">
              <Link to={`${url}/lds`}>
                <BizButton title="Lead Data Sheet" theme="lac"><Icon style={{ fontSize: 22, color: '#FFFFFF' }}>description</Icon></BizButton>
              </Link>
            </div>
            {
              statusLogsList.includes('lead-lds-approved') ?
                <div className="col-auto">
                  <Link to={`${url}/las`}>
                    <BizButton title="Lead Approval Sheet" theme="lac"><Icon style={{ fontSize: 22, color: '#FFFFFF' }}>assignment_turned_in</Icon></BizButton>
                  </Link>
                </div>
                :
                null
            }
            {
              statusLogsList.includes('lead-las-approved') ?
                <div className="col-auto">
                  <Link to={`${url}/lcs`}>
                    <BizButton title="Lead Conversion Sheet" theme="lac"><Icon style={{ fontSize: 22, color: '#FFFFFF' }}>restore_page</Icon></BizButton>
                  </Link>
                </div>
                :
                null
            }
            {
              statusLogsList.includes('lead-mandate-created') ?
                <div className="col-auto">
                  <a href={`${baseUrl}/mandate`}>
                    <BizButton title="Mandate" theme="lac"><Icon style={{ fontSize: 22, color: '#FFFFFF' }}>description</Icon></BizButton>
                  </a>
                </div>
                :
                null
            }
          </div>

          <div className="row" style={{ marginTop: 25 }}>
            {/* New lead options */}
            {
              status === 'lead-created' || status === 'lead-ldsFis' ?
                <div className="col-auto">
                  <Button
                    size="large"
                    onClick={() => {
                      this.props.mutate({
                        variables: {
                          customerId: params.cid,
                          status: 'lead-lds-approved',
                        },
                      })
                        .then(() => {
                          this.props.history.push(`/app/lead/${params.cid}`);
                        });
                    }}
                  >
                    Approve Lead Data Sheet
                  </Button>
                </div>
                :
                null
            }
            {
              status === 'lead-created' ?
                <div className="col-auto">
                  <Link to={`${url}/lds/fis/request`}>
                    <Button size="large">Further Information Request</Button>
                  </Link>
                </div>
                :
                null
            }
            {
              status === 'lead-ldsFis-request' ?
                <div className="col-auto">
                  <Link to={`${url}/lds/fis`}>
                    <Button size="large">Further Information Sheet</Button>
                  </Link>
                </div>
                :
                null
            }

            {/* LAS options */}
            {
              status === 'lead-las' ?
                <div className="col-auto">
                  <Button
                    size="large"
                    onClick={() => {
                      this.props.mutate({
                        variables: {
                          customerId: params.cid,
                          status: 'lead-las-approved',
                        },
                      })
                        .then(() => {
                          this.props.history.push(`/app/lead/${params.cid}`);
                        });
                    }}
                  >
                    Approve Lead Approval Sheet
                  </Button>
                </div>
                :
                null
            }
            {
              status === 'lead-las' ?
                <div className="col-auto">
                  <Button
                    size="large"
                  >
                    Reject Lead Approval Sheet
                  </Button>
                </div>
                :
                null
            }

            {/* LCS options */}
            {
              status === 'lead-las-approved' ?
                <div className="col-auto">
                  <Link to={`${url}/lcs/fis/request`}>
                    <Button size="large">Further Information Request</Button>
                  </Link>
                </div>
                :
                null
            }
            {
              status === 'lead-lcsFis-request' ?
                <div className="col-auto">
                  <Link to={`${url}/lcs/fis`}>
                    <Button size="large">Further Information Sheet</Button>
                  </Link>
                </div>
                :
                null
            }
            {
              status === 'lead-lcs' ?
                <div className="col-auto">
                  <Button
                    size="large"
                    onClick={() => {
                      this.props.mutate({
                        variables: {
                          customerId: params.cid,
                          status: 'lead-lcs-approved',
                        },
                      })
                        .then(() => {
                          this.props.history.push(`/app/lead/${params.cid}`);
                        });
                    }}
                  >
                    Approve Lead Conversion Sheet
                  </Button>
                </div>
                :
                null
            }
            {
              status === 'lead-lcs' ?
                <div className="col-auto">
                  <Button
                    size="large"
                  >
                    Reject Lead Conversion Sheet
                  </Button>
                </div>
                :
                null
            }
          </div>

          <Switch>
            <Route
              exact
              path={path}
              render={() => {
                if (status === 'lead-created' || status === 'lead-ldsFis') return <Redirect to={`${url}/lds`} />;
                if (status === 'lead-ldsFis-request') return <Redirect to={`${url}/lds/fis`} />;
                if (status === 'lead-lds-approved' || status === 'lead-las') return <Redirect to={`${url}/las`} />;
                if (status === 'lead-las-approved' || status === 'lead-lcsFis' || status === 'lead-lcs') return <Redirect to={`${url}/lcs`} />;
                if (status === 'lead-lcsFis-request') return <Redirect to={`${url}/lcs/fis`} />;
                if (status === 'lead-lcs-approved') return <Redirect to={`${url}/mandate/create`} />;
                // if (status === 'lead-mandate-created') return <Redirect to={`${url}/mandate`} />;
                return <Redirect to={`${url}/lds`} />;
              }}
            />
            <Route exact path={`${path}/lds`} render={(renderProps) => (<LeadDataSheet {...renderProps} leadDataSheet={lds} fis={ldsFis} />)} />
            <Route path={`${path}/lds/fis/request`} component={LdsFisRequest} />
            <Route path={`${path}/lds/fis`} render={(renderProps) => (<LdsFis {...renderProps} fis={ldsFis} docs={docs} />)} />
            <Route
              path={`${path}/las`}
              render={(renderProps) => {
                if (status === 'lead-lds-approved') {
                  return (
                    <LeadApprovalSheetForm
                      {...renderProps}
                      companyName={name}
                      currentProposal={lds.currentProposal}
                      immovableSecurities={ldsFis.securitiesRequested ? ldsFis.immovableSecurities : null}
                      movableSecurities={ldsFis.securitiesRequested ? ldsFis.movableSecurities : null}
                      amountUnit={lds.amountUnit}
                    />
                  );
                }
                // Show LAS only after LDS is approved
                if (!statusLogsList.includes('lead-lds-approved')) {
                  return <Redirect to={`${url}/lds`} />;
                }
                return (<LeadApprovalSheet
                  {...renderProps}
                  las={las}
                  amountUnit={lds.amountUnit}
                />);
              }}
            />
            <Route path={`${path}/lcs/fis/request`} component={LcsFisRequest} />
            <Route
              path={`${path}/lcs/fis`}
              render={(renderProps) => (<LcsFisForm {...renderProps} lcsFis={lcsFis} docs={docs} />)}
            />
            <Route
              path={`${path}/lcs`}
              render={(renderProps) => {
                // Show LCS only after LAS is approved
                if (!statusLogsList.includes('lead-las-approved')) {
                  return <Redirect to={`${url}/lds`} />;
                }
                if (status === 'lead-las-approved' || status === 'lead-lcsFis') {
                  return (
                    <LeadConversionSheetForm
                      {...renderProps}
                      companyName={name}
                      lcsFis={lcsFis}
                    />
                  );
                }
                if (status === 'lead-lcsFis-request') {
                  return <Redirect to={`${url}/lcs/fis`} />;
                }
                return (
                  <LeadConversionSheet
                    {...renderProps}
                    lcs={lcs}
                    lcsFis={lcsFis}
                  />
                );
              }}
            />

            <Route
              path={`${path}/mandate/create`}
              render={(renderProps) => {
                if (status !== 'lead-lcs-approved') {
                  return <Redirect to={`${url}/lcs`} />;
                }
                return (
                  <MandateCreate
                    {...renderProps}
                    companyName={name}
                    fees={las.proposedFees}
                  />
                );
              }}
            />
          </Switch>
        </div>
      </div>
    );
  }
}

LeadPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      cid: PropTypes.string.isRequired,
    }),
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    lead: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  }).isRequired,
  mutate: PropTypes.func.isRequired,
};

export default compose(
  graphql(QUERY, {
    options: ({ match }) => ({ variables: { customerId: match.params.cid } }),
  }),
  graphql(statusLogMutation),
)(LeadPage);



// WEBPACK FOOTER //
// ./src/pages/leads/LeadPage.jsx